import React, { CSSProperties, FC } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

type Props = {
  onClick?: () => void;
  style?: CSSProperties;
};

const ButtonStyled = styled(Button)`
  -webkit-box-shadow: 1px 1px 6px 1px rgba(0,0,0,0.38);
  box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.38);
  max-width: 480px;
`;

export const ActionButton: FC<Props> = ({ children, onClick, style }) => (
  <ButtonStyled
    type={'primary'}
    className={'form-button'}
    htmlType="button"
    style={style}
    onClick={onClick}
  >
    {children}
  </ButtonStyled>
);
